import { IconCalendarMonth, IconChartBar, IconHandClick } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import { getApi } from '../../api/call.api';
import { urlApi } from '../../api/url.api';
import AnalysisGraph from '../../components/AnalysisComponents/AnalysisGraph';
import BrowserDonutChart from '../../components/AnalysisComponents/BrowserDonutChart';
import LocationTable from '../../components/AnalysisComponents/LocationTable';
import OsDonutChart from '../../components/AnalysisComponents/OsDonutChart';
import Layout from '../../layout/Layout';
import { formatDateToShortMonthDayYear } from '../../utils/dateTimeConverter';
import TablePreview from './Components/PageTemplates/TablePreview';

const PageDetails = () => {
    const { state } = useLocation();
    const [subLinkList, setSubLinkList] = useState([{
        linkId: state?.linkId,
        name: 'Main Page',
        type: 'Page',
        shortLink: state?.shortLink,
        mainLink: state?.mainLink,
    }]);
    const [selectedSubLink, setSelectedSubLink] = useState(state?.linkId);

    async function getList() {
        let resp = await getApi(urlApi.getSubLinksOfPage + state?.linkId);
        let localResp = [...subLinkList, ...resp?.data]
        setSubLinkList(localResp);
    }

    useEffect(() => {
        getList();
    }, []);

    return (
        <Layout>
            <div className='flex flex-wrap justify-between'>
                <div className='flex gap-3 p-3 rounded-lg bg-white mb-3'>
                    <TablePreview pageData={state?.pageData} />
                    <div>
                        <p className="mb-0.5 font-semibold text-sm text-[var(--black)]">{state?.linkName}</p>
                        <Link to={state?.shortLink} target='_blank'> <p className="mb-0.5 font-semibold text-primary text-sm">{state?.shortLink}</p></Link>
                        <Link to={state?.mainLink} target='_blank'><p className="mb-0.5 text-xs italic text-[var(--black)] max-line-2">{state?.mainLink}</p></Link>
                        <div className="flex gap-2">
                            <p className={`font-semibold text-[10px] ${state?.linkClicks > 0 ? 'text-green-500' : 'text-[#BDBDBD]'} inline-flex items-center gap-1 mb-0`}> <span> <IconChartBar size={16} /> </span> {state?.linkClicks ?? "0"} engagements</p>
                            <p className={`font-semibold text-[10px] ${state?.uniqueLinkClicks > 0 ? 'text-green-500' : 'text-[#BDBDBD]'} inline-flex items-center gap-1 mb-0`}> <span> <IconHandClick size={16} /> </span> {state?.uniqueLinkClicks ?? "0"} unique clicks</p>
                            <p className="font-semibold text-[10px] text-[#BDBDBD] inline-flex items-center gap-1 mb-0"> <span> <IconCalendarMonth size={16} /> </span> {formatDateToShortMonthDayYear(state?.createdAt)}</p>
                        </div>
                    </div>
                </div>

                <Dropdown>
                    <Dropdown.Toggle className='primary-outline-btn' id="dropdown-basic">
                        Select Link
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                        {
                            subLinkList.map((subLink, index) => (
                                <Dropdown.Item key={index} onClick={() => setSelectedSubLink(subLink?.linkId)}>
                                    <div className='!border rounded-lg shadow-sm mb-1 p-2'>
                                        <p className="mb-0 text-xs font-medium text-gray-600">{subLink?.type} {subLink?.name && `(${subLink?.name})`} </p>
                                        <p className="mb-0 text-sm font-medium whitespace-break-spaces">{subLink?.mainLink}</p>
                                    </div>
                                </Dropdown.Item>
                            ))
                        }
                    </Dropdown.Menu>
                </Dropdown>

            </div>
            <div className='mb-3'><AnalysisGraph linkId={selectedSubLink} title={"Clicks"} subTitle={"Clicks"} /></div>
            <div className='mb-3'><LocationTable linkId={selectedSubLink} title={"Clicks"} /></div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div className="col-span-1">
                    <BrowserDonutChart linkId={selectedSubLink} title={"Clicks"} />
                </div>
                <div className="col-span-1">
                    <OsDonutChart linkId={selectedSubLink} title={"Clicks"} />
                </div>
            </div>
        </Layout>
    )
}

export default PageDetails